import { render, staticRenderFns } from "./vision.vue?vue&type=template&id=19438c29&"
import script from "./vision.vue?vue&type=script&lang=js&"
export * from "./vision.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports